var styleDataHash = "a05322dc";
const injectCss = (() => {
  var css = `.pJQBK{height:18px;position:relative;width:18px}.-V07k,._7VE-2{height:100%;left:0;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}.-V07k{animation:_6si8W 666ms linear infinite;opacity:.3}.-V07k,._7VE-2{stroke:currentColor}._7VE-2{animation:_6si8W 2s linear infinite}@keyframes _6si8W{to{transform:rotate(1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var double_loader_default = {
  "wrapper": "pJQBK",
  "top": "-V07k",
  "bottom": "_7VE-2",
  "rotation": "_6si8W"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
